package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.BillingOverview
import com.ijoin.data.model.MoneyAmount
import com.ijoin.data.model.PayoutMethod
import com.ijoin.data.model.PayoutRequest
import com.ijoin.data.repository.BillingFilter
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.Serializable

class BillingApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/billing"

    suspend fun getOverview(filter: BillingFilter): Result<BillingOverview> {
        return safeApiCall {
            client.get("$baseUrl/overview") {
                addAuthToken()
                parameter("range", filter.name)
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun requestWithdrawal(
        amount: MoneyAmount,
        method: PayoutMethod,
        details: Map<String, String>,
        note: String? = null
    ): Result<PayoutRequest> {
        return safeApiCall {
            client.post("$baseUrl/payouts") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(
                    CreatePayoutRequestBody(
                        amount = amount.value,
                        currency = amount.currency,
                        method = method,
                        details = details,
                        note = note
                    )
                )
            }
        }.mapCatching { response -> response.body() }
    }

    @Serializable
    private data class CreatePayoutRequestBody(
        val amount: Double,
        val currency: String,
        val method: PayoutMethod,
        val details: Map<String, String>,
        val note: String? = null
    )
}
